import { combineReducers } from 'redux';
import type { Reducer } from 'redux';

import { landlordReducer } from '@rental-manager/reducers';
import { renterReducer } from '@renter-hub/reducers';
import app from './app';
import user from './user';

const paymentsReducer = combineReducers({
  landlord: landlordReducer,
  renter: renterReducer,
});

const rootReducer = (routerReducer: Reducer) =>
  combineReducers({
    app,
    payments: paymentsReducer,
    user,
    router: routerReducer,
  });

export default rootReducer;
